import { LiipGPTClient } from "./LiipGPTClient";
import { API_KEY, BACKEND_URL } from "~src/config/env";

export const client = new LiipGPTClient({
  apiUrl: BACKEND_URL,
  apiKey: API_KEY || "",
});
